import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useBusiness } from '../../contexts/BusinessContext';

const CreateBusiness2 = () => {
  const [businessName, setBusinessName] = useState('');
  const { user } = useAuth();
  const { createBusiness } = useBusiness();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const business = await createBusiness({
        name: businessName,
        description: `Negocio 2 creado por ${user.email}`
      });
      window.location.reload();
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Crear Negocio 2</h1>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Nombre del Negocio
          </label>
          <input
            type="text"
            value={businessName}
            onChange={(e) => setBusinessName(e.target.value)}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
            placeholder="Ingresa el nombre de tu negocio"
            required
          />
        </div>
        <button
          type="submit"
          className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700"
        >
          Crear Negocio 2
        </button>
      </form>
    </div>
  );
};

export default CreateBusiness2; 